import { IUser } from '../user/interface';
import config from '../../config';

// Pendo must be initialized only once per page load
let isPendoInitialized = false;

export const initializePendo = (user: IUser) => {
    const appStage = config.APP_STAGE;
    const pendo = (window as any)?.pendo;
    const options = {
        visitor: {
            id: `${user.user_id}-${appStage}`,
            email: user.user_email,
            full_name: `${user.user_fname || ''} ${user.user_lname || ''}`,
            role: user.user_type,
        },
        account: {
            id: `${user.company_id}-${appStage}`,
            // Pendo strongly recommends sending account metadata along with the account id
            name: user.company?.company_name,
        },
    };

    // User is fetched again after profile save - only send the updated data to Pendo
    if (isPendoInitialized) {
        pendo?.updateOptions(options);
        return;
    }

    pendo?.initialize(options);
    isPendoInitialized = true;
};
